// src/common/NotificationAlert/index.js
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Slide } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import useStyles from "./styles";

const NotificationAlert = ({ message, onClose, duration = 2000 }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    setTimeout(onClose, 300); // Esperar la animación de salida
  };

  useEffect(() => {
    const timer = setTimeout(handleClose, duration);
    return () => clearTimeout(timer);
  }, [duration]);

  return (
    <Slide direction="up" in={open} mountOnEnter unmountOnExit>
      <div className={`${classes.alertContainer} ${classes.info}`}>
        <span className={classes.alertMessage}>{message}</span>
        <IconButton size="small" onClick={handleClose} className={classes.alertClose}>
          <Icon>close</Icon>
        </IconButton>
      </div>
    </Slide>
  );
};

NotificationAlert.propTypes = {
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  duration: PropTypes.number,
};

export default NotificationAlert;
